module.exports = __webpack_public_path__ + "media/images/icons/email-1fd37201a7b10654179c86cdbc00b5b4.svg";